import TermHeader from "./TermHeader";

export default TermHeader;